import i18next from 'i18next';
import OrdersLogo from '../../../../../components/Shared/Icons/OrdersLogo';
import OrderCreate from '../../../../../components/Orders/Item/OrderCreate';
import OrderEdit from '../../../../../components/Orders/Item/OrderEdit';
import Orders from '../../../../../components/Orders/List';

// const ORDER_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/orders',
//   exact: true,
//   additional: {
//     component: Orders,
//     protected: true,
//     title: i18next.t('titles:orders'),
//     icon: OrdersLogo,
//   },
// };

const ORDER_ROUTE_LIST = {
  path: '/:currentAccountUuid/orders',
  exact: true,
  additional: {
    component: Orders,
    protected: true,
    title: i18next.t('titles:orders'),
    icon: OrdersLogo,
  },
};

const ORDER_ROUTE_CREATE_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/orders/:reorderUuid/create',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST, //ORDER_ROUTE_LIST_DS,
  additional: {
    component: OrderCreate,
    protected: true,
    title: i18next.t('titles:createOrder'),
  },
};

const ORDER_ROUTE_EDIT_DS = {
  path: '/:currentAccountUuid/accounts/:accountUuid/patients/:patientUuid/orders/:orderUuid/edit',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST, //ORDER_ROUTE_LIST_DS,
  additional: {
    component: OrderEdit,
    protected: true,
    title: i18next.t('titles:editOrder'),
  },
};



const ORDER_ROUTE_CREATE = {
  path: '/:currentAccountUuid/patients/:patientUuid/orders/:reorderUuid/create',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST,
  additional: {
    component: OrderCreate,
    protected: true,
    title: i18next.t('titles:createOrder'),
  },
};

const ORDER_ROUTE_EDIT = {
  path: '/:currentAccountUuid/patients/:patientUuid/orders/:orderUuid/edit',
  exact: true,
  parentRoute: ORDER_ROUTE_LIST,
  additional: {
    component: OrderEdit,
    protected: true,
    title: i18next.t('titles:editOrder'),
  },
};

export const ORDER_ROUTES = {
  // ------- For child accounts ------
  // listDS: ORDER_ROUTE_LIST_DS,
  createDS: ORDER_ROUTE_CREATE_DS,
  editDS: ORDER_ROUTE_EDIT_DS,

  // ------- For current accounts ------
  list: ORDER_ROUTE_LIST,
  create: ORDER_ROUTE_CREATE,
  edit: ORDER_ROUTE_EDIT,
};
